import script from "./profilePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./profilePopup.vue?vue&type=script&setup=true&lang=ts"

import "./profilePopup.vue?vue&type=style&index=0&id=b87d0466&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b87d0466"]])

export default __exports__